export const adminRole = 1;
export const userRole = 3;
export const managerRole = 4;
export const viewerRole = 5;
